import { cleanup, render, screen } from '@testing-library/react';
import * as React from 'react';

import ItemIcon from './item-icon';

describe('customer group selector item icon', () => {
  afterEach(() => {
    cleanup();
  });

  test('should render the customer group selector item icon with a null icon', async () => {
    render(<ItemIcon />);

    const component = screen.queryByTestId('item-icon');
    expect(component).toBeNull();
  });
});
